export default __webpack_public_path__ + "static/media/air-import-dark.cfef8aec.svg";